export enum ZepApiStatusType {
  SUCCESS = 0,
  FAILED = -1,
  NOT_MATCHED_DOMAIN = -2, // 도메인 불일치
  NOT_ALLOWED_GUEST = -3, // 허용되지 않은 게스트
  NOT_FOUND_PLAYER = -4, // 플레이어 찾을 수 없음
  NOT_FOUND_ROOM = -5, // 스페이스 찾을 수 없음
  ROOM_FULL = -6, // 스페이스 꽉 참
  PLEASE_LOGIN = -7, // 로그인 필요
  WRONG_SECRET = -8, // 시크릿 불일치
  WRONG_VERSION = -9, // 접속자 버전, 게임 허브 버전과 비교하여 낮을 시
  NOT_AVAILABLE_SPACE_CHANNEL = -14, // 접속 가능한 채널이 없을때
  NOT_FOUND_SPACE_SERVER = -15, // 접속 가능한 서버 머신을 찾을 수 없을때
  SHOULD_REDIRECT = -17, // redirect 가 필요할때
  NOT_FOUND_SPACE = -48, // 스페이스를 찾을 수 없습니다.
  NO_PERMISSION_TO_EDIT_SPACE_MAP = -50, // 스페이스 맵을 수정할 권한이 없습니다.
  NOT_FOUND_SPACE_GAME = -55, // 스페이스 게임을 찾지 못했습니다
  DUPLICATE_SIGN_DETECTED_IN_SPACE = -66, // 이미 스페이스에 접속중인 계정입니다.
  IS_NOT_IMAGE_FILE = -84, // 이미지 파일이 아닙니다.
  TOO_MANY_SIGNIN_TRIAL = -94,
  AUTH_CONFIRM_CODE_INVALID = -95, // 인증 코드가 유효하지 않습니다.
  AUTH_CONFIRM_EXPIRED = -96, // 인증 시간이 만료되었습니다.
  SPACE_FULL = -133, // 스페이스 최대 접속 인원에 도달했습니다.
  CHANNEL_FULL = -134, // 채널 최대 접속 인원에 도달했습니다.
  SIZE_LIMIT_EXCEEDED = -152,
  NOT_FOUND_BILLING_KEY = -153, // 해당 키로 등록된 결제 정보가 없습니다.
  NO_PERMISSION_TO_MANAGE_PREMIUM_PLAN = -154, // 프리미엄 플랜 관리 권한이 없는 계정입니다.
  PLAN_ALREADY_EXISTS = -161, // 이미 예정된 플랜이 존재합니다.
  TOO_MANY_SPACE_OWNER = -173, // 스페이스 내에 어드민 권한이 5명 이상일 경우
  NOT_FOUND_ENTRY_SCRIPT_FILE = -189,
  NOT_VALID_ZIP_FILE = -190,
  NOT_AGREED_TERMS_OR_PRIVACY_POLICY = -192,
  TOO_MANY_AUTH_CODE_FAILURES = -194,
  ALREADY_PURCHASED = -199, // 이미 해당 영수증으로 충전이 완료된 경우
  NO_PERMISSION_FOR_OPERATION = -200, // 해당 작업을 수행할 권한이 없습니다.
  ALREADY_READY_SPACE_PLAN_EXISTS = -209, // 이미 해당 스페이스에 적용 예정인 플랜이 존재합니다.
  FAIL_TO_EDIT_ZIP_CODE = -211, // 우편번호 수정 중 DB 업데이트 실패한 경우
  NOT_ALLOWED_TO_DELETE_ACTIVE_PLAN = -212, // Active 상태인 플랜이 있어서 삭제 불가
  FAILED_TO_GOOGLE_AUTH = -217, // 구글 인증 실패
  NOT_ALLOWED_TO_DOWNLOAD_INVALID_INPUT_DATETIME = -218, // 유효하지 않은 입력값으로 방문기록 다운로드 요청
  NOT_VALID_CSV_FILE = -222, // 유효하지 않은 CSV 파일입니다.
  IS_BLACKLIST_USER = -223, // 스페이스 블랙리스트
  DUPLIACED_INVITED_USER = -224, // 중복 초대된 유저입니다.
  TOO_MANY_RECORDING_EMAIL_RESEND = -247, // 녹화 이메일 재전송은 5분 후에 다시 시도해 주세요
  NO_PERMISSION_TO_RESEND_RECORDING_EMAIL = -248, // 녹화를 시작한 본인만 이메일을 재전송할 수 있습니다
}
